import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      toast.warning('Ingrese usuario y contraseña');
      return;
    }

    setLoading(true);

    try {
      const result = await login(username.trim(), password);

      if (result.success) {
        toast.success('Bienvenido al sistema');
        navigate('/', { replace: true });
      } else {
        toast.error(result.error || 'Credenciales incorrectas');
      }
    } catch (error) {
      const mensaje = error.response?.data?.error || 'Error al iniciar sesión';
      toast.error(mensaje);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card fade-in">
        <img
          src={`${process.env.PUBLIC_URL}/logo-horizontal.png`}
          alt="Oftalmetryc"
          className="login-logo"
        />

        <h4 className="login-title">Bienvenido</h4>
        <p className="login-subtitle">Ingrese sus credenciales para acceder al sistema</p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label text-muted small">Usuario o Email</label>
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <i className="bi bi-person text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Ingrese su usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
                autoFocus
                autoComplete="username"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label text-muted small">Contraseña</label>
            <div className="input-group">
              <span className="input-group-text bg-light border-end-0">
                <i className="bi bi-lock text-muted"></i>
              </span>
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-control border-start-0 border-end-0"
                placeholder="Ingrese su contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="input-group-text bg-light border-start-0"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} text-muted`}></i>
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                Ingresando...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Ingresar
              </>
            )}
          </button>
        </form>

        <div className="text-center mt-4">
          <small className="text-muted">
            Desarrollado por{' '}
            <a href="https://www.keybidigital.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 600 }}>
              Keybidigital
            </a>
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;
